// import React, { useState, useEffect } from "react";
// import { Formik, Form } from "formik";
// import { Button, Container, Row, Col, CardBody, Card } from "reactstrap";
// import { useDispatch } from "react-redux";
// import { getCategoryWithId, updateCategoryStatus, createCategory } from "../../slices/thunks";
// import { useLocation, useNavigate } from "react-router-dom";
// import NameInput from "../../common/NameInput";
// import BreadCrumb from '../../Components/Common/BreadCrumb';
// import DropdownInput from "../../common/DropdownInput";
// import TextInput from "../../common/textInput"; // You can implement this component based on your design

// const Categoryform = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const categoryId = location.state?.id;
//   const [categoryData, setCategoryData] = useState(null);
//   const [validateTrigger, setValidateTrigger] = useState(false);

//   useEffect(() => {
//     if (categoryId) {
//       dispatch(getCategoryWithId(categoryId))
//         .then((response) => {
//           const data = response.payload?.data?.data;
//           if (data) setCategoryData(data);
//         })
//         .catch((error) => console.error("Error fetching category:", error));
//     }
//   }, [categoryId, dispatch]);

//   const handleSubmit = (values, { resetForm }) => {
//     const payload = {
//       name: values?.name,
//       status: values.dropdown === "Active",
//     };

//     if (categoryId) {
//       dispatch(updateCategoryStatus({ id: categoryId, payload }))
//         .unwrap()
//         .then(() => {
//           resetForm();
//           navigate("/Category");
//         })
//         .catch((error) => console.error("Error updating category:", error));
//     } else {
//       dispatch(createCategory(payload))
//         .unwrap()
//         .then(() => {
//           resetForm();
//           navigate("/Category");
//         })
//         .catch((error) => console.error("Error creating category:", error));
//     }
//   };

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid>
//           <BreadCrumb title={categoryId ? "Update Category" : "Add Category"} pageTitle="Categories" />
//         </Container>
//       </div>

//       <div className="page-content justify-content-center align-items-center">
//         <Container fluid>
//           <Card>
//             <CardBody>
//               <Formik
//                 enableReinitialize
//                 initialValues={{
//                   name: categoryData?.name ?? "",
//                   dropdown: categoryData?.status === false ? "Inactive" : "Active",
//                 }}
//                 onSubmit={(values, actions) => {
//                   setValidateTrigger(true);
//                   handleSubmit(values, actions);
//                 }}
//               >
//                 {(formik) => (
//                   <Form className="p-4 border rounded shadow-sm bg-white">
//                     <h2 className="mb-4">{categoryId ? "Update Category" : "Add Category"}</h2>

//                     <Row className="mb-3">
                    
//                       <Col lg={6} md={12} sm={12}>
//                         <NameInput
//                           name="name"
//                           required
//                           showHelp={true}
//                           helpText="Please enter category name."
//                           requiredErrorMessage="Category name is required."
//                           validateTrigger={validateTrigger}
//                           onChange={formik.handleChange}
//                           value={formik.values.name}
//                           label="Category Name"
//                         />
//                       </Col>
//                       <Col lg={6} md={12} sm={12}>
//                         <DropdownInput
//                           label="Status"
//                           name="dropdown"
//                           id="dropdownInput"
//                           options={[
//                             { label: "Active", value: "Active" },
//                             { label: "Inactive", value: "Inactive" },
//                           ]}
//                           required={true}
//                           showHelp={true}
//                           validateTrigger={validateTrigger}
//                           requiredErrorMessage="Please select a status."
//                           onChange={(selectedOption) =>
//                             formik.setFieldValue("dropdown", selectedOption ? selectedOption.value : "")
//                           }
//                           onBlur={() => formik.setFieldTouched("dropdown", true)}
//                           defaultSelectedKey={formik.values.dropdown}
//                           placeholder="Select status"
//                         />
//                       </Col>
//                     </Row>

                 

//                     <Row className="mt-4">
//                       <Col lg={12} className="d-flex justify-content-end">
//                         <Button type="submit" color="primary">
//                           {categoryId ? "Update" : "Add"} Category
//                         </Button>
//                       </Col>
//                     </Row>
//                   </Form>
//                 )}
//               </Formik>
//             </CardBody>
//           </Card>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };


// export default Categoryform;
import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import {
  Button,
  Container,
  Row,
  Col,
  CardBody,
  Card
} from "reactstrap";
import { useDispatch } from "react-redux";
import {
  getCategoryWithId,
  updateCategoryStatus,
  createCategory
} from "../../slices/thunks";
import { useLocation, useNavigate } from "react-router-dom";
import NameInput from "../../common/NameInput";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import SwitchInput from "../../common/SwitchInput";

const Categoryform = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const categoryId = location.state?.id;

  const [categoryData, setCategoryData] = useState(null);
  const [validateTrigger, setValidateTrigger] = useState(false);

  useEffect(() => {
    if (categoryId) {
      dispatch(getCategoryWithId(categoryId))
        .then((response) => {
          const data = response.payload?.data?.data;
          if (data) setCategoryData(data);
        })
        .catch((error) => console.error("Error fetching category:", error));
    }
  }, [categoryId, dispatch]);

  const handleSubmit = (values, { resetForm }) => {
    const payload = {
      name: values?.name,
      status: values?.status
    };

    const action = categoryId
      ? updateCategoryStatus({ id: categoryId, payload })
      : createCategory(payload);

    dispatch(action)
      .unwrap()
      .then(() => {
        resetForm();
        navigate("/Category");
      })
      .catch((error) => console.error("Error submitting category:", error));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={categoryId ? "edit Category" : "Add Category"}
            pageTitle="Categories"
          />
        </Container>
      </div>

      <div className="page-content justify-content-center align-items-center">
        <Container fluid>
          <Card>
            <Formik
              enableReinitialize
              initialValues={{
                name: categoryData?.name ?? "",
                status:
                  categoryData?.status === "Active" ||
                  categoryData?.status === true
              }}
              onSubmit={(values, actions) => {
                setValidateTrigger(true);
                handleSubmit(values, actions);
              }}
            >
              {(formik) => (
                <Form className="p-4 border rounded shadow-sm bg-white">
                  {/* <h2 className="mb-4">
                    {categoryId ? "Update Category" : "Add Category"}
                  </h2> */}

                  <Row className="mb-3">
                    <Col lg={6} md={12} sm={12}>
                      <NameInput
                        name="name"
                        required
                        label="Category Name"
                        showHelp={true}
                        helpText="Please enter category name."
                        requiredErrorMessage="Category name is required."
                        validateTrigger={validateTrigger}
                        onChange={formik.handleChange}
                        value={formik.values.name}
                      />
                    </Col>

                    <Col lg={6} md={12} sm={12}>
                      <div className="d-flex align-items-center gap-3">
                        <SwitchInput
                        label="Status"
                          name="status"
                          checked={formik.values.status}
                          onChange={(val) =>
                            formik.setFieldValue("status", val)
                          }
                          switchColor="#28a745"
                          switchOffColor="#dc3545"
                        />
                        <span className="fw-semibold"></span>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-4">
                    <Col lg={12} className="d-flex justify-content-end">
                      <Button type="submit" color="primary">
                        {categoryId ? "Update" : "Add"} Category
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Categoryform;
